import React, { useContext, useEffect, useState } from 'react'
import { CButton, CCard, CFormSelect } from '@coreui/react'
import useAxios from 'axios-hooks'
import { CUSTOM_FORM_ANALYTICS, CUSTOM_FORM_ANALYTICS_DOWNLOAD } from '../../utils/urls'
import { AppContext } from '../../context/app'
import { isEmpty } from 'lodash'
import { useParams, useHistory } from 'react-router-dom'
import { PAGE_SIZE } from 'src/views/utils/constants'
import BackIcon from '../../../assets/small-back-arrow.svg'
import ArrowIcon from '../../../assets/double-arrow-icon.svg'
import DownloadIcon from '../../../assets/small-download-icon.svg'
import InfiniteScroll from 'react-infinite-scroll-component'
import FormAnalyticsCard from './formAnalyticsCard'
import FormPreview from './formPreview'
import { getThumbnail } from 'src/views/utils/helper'
import { GlobalContext } from 'src/views/context/GlobalState'
import moment from 'moment'

const FormAnalyticsDetails = () => {
  let { formId } = useParams()
  const history = useHistory()
  const [allFormData, setAllFormData] = useState([])
  const [formData, setFormData] = useState({})
  const [responseData, setResponseData] = useState([])
  const { userSessionObj } = useContext(GlobalContext)
  const { setLoader } = useContext(AppContext)
  const [page, setPage] = useState(1)
  const [previewInfo, setPreviewInfo] = useState([])

  const [{ data: formResponseData, loading: formResponseLoading }, formResponseCall] = useAxios(
    {
      url: CUSTOM_FORM_ANALYTICS,
      method: 'post',
    },
    { manual: true },
  )
  const [{ data: formList, loading: formListLoading }, formListCall] = useAxios(
    {
      url: CUSTOM_FORM_ANALYTICS,
      method: 'get',
    },
    { manual: true },
  )

  const [{ loading: downloadExcelLoading, response: downloadExcelResponse }, downloadExcelCall] =
    useAxios(
      {
        url: `${CUSTOM_FORM_ANALYTICS_DOWNLOAD}`,
        method: 'get',
        responseType: 'arraybuffer',
      },
      { manual: true },
    )

  const handleDownload = () => {
    downloadExcelCall({
      params: {
        form_id: formId,
      },
    })
  }

  useEffect(() => {
    if (formId) {
      setPage(1)
      formResponseCall({
        data: {
          form_id: formId,
          page: 1,
          page_size: PAGE_SIZE,
          order_by: 'created_date',
          reverse: false,
        },
      })
      setPreviewInfo([])
    }

    if (isEmpty(allFormData)) {
      formListCall()
    }
  }, [formId])

  useEffect(() => {
    if (downloadExcelResponse && downloadExcelResponse.status === 200) {
      const blob = new Blob([downloadExcelResponse.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `form-analytics-${formData?.name}-report.xlsx`
      link.click()
    }
  }, [downloadExcelResponse])

  useEffect(() => {
    setLoader(formResponseLoading || formListLoading || downloadExcelLoading)
  }, [formResponseLoading, formListLoading, downloadExcelLoading])

  useEffect(() => {
    if (formList && formList.success) {
      setAllFormData(formList.data)
    }
  }, [formList])

  useEffect(() => {
    if (formResponseData && formResponseData.success) {
      if (page === 1) {
        setFormData(formResponseData?.data?.form_data)
        setResponseData(formResponseData?.data?.responses?.data)
      } else {
        setResponseData((responseData) => [
          ...responseData,
          ...formResponseData?.data?.responses?.data,
        ])
      }
    }
  }, [formResponseData])

  const handleNextPage = () => {
    formResponseCall({
      data: {
        form_id: formId,
        page: page + 1,
        page_size: PAGE_SIZE,
        order_by: 'created_date',
        reverse: false,
      },
    })
    setPage((page) => page + 1)
  }

  const handlePreview = (info, date) => {
    let tempArr = info.map((data) => ({
      property: `${data?.name}:`,
      value: data?.value,
    }))

    tempArr.push({
      property: `Created on:`,
      value: date,
    })
    setPreviewInfo(tempArr)
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mt-4">
        <div className="w-100 ">
          <div className="d-flex align-items-center justify-content-between w-100 ">
            <div className="d-flex align-items-center">
              <h4 style={{ fontSize: '1.5625vw' }} className="font-bold mb-0">
                Custom Forms Analytics
              </h4>
              <img src={ArrowIcon} alt="ArrowIcon" className="mx-2" />
              <h4 style={{ fontSize: '1.5625vw' }} className="font-bold mb-0">
                {formData?.name}
              </h4>
            </div>
            <CButton
              className="text-white px- py-1"
              onClick={() => {
                history.push('/custom-forms/analytics')
              }}
              style={{ pointerEvents: 'auto', fontSize: '18px', background: '#20211c' }}
            >
              <img src={BackIcon} alt="BackIcon" className="mr-2" />
              Back
            </CButton>
          </div>
          <p>Following are the Custom Form Responses.</p>
        </div>
      </div>
      <div
        className="d-flex justify-content-between align-items-center "
        style={{
          margin: '0 auto 3vh',
          width: '100%',
        }}
      >
        <div style={{ fontSize: '0.9vw' }}>{`Showing ${responseData?.length} of ${
          formResponseData?.data?.responses?.total || 0
        }`}</div>

        <div className="d-flex align-items-end justify-content-end w-50">
          <div style={{ width: '38.6%' }} className="mx-5">
            <p style={{ fontSize: '0.73vw', fontWeight: '550' }} className="mb-0">
              Select Form
            </p>
            <CFormSelect
              value={formData?._id}
              style={{ backgroundColor: 'inherit' }}
              className="w-full"
              onChange={(e) => history.push(`/form-analytics-detail/${e.target.value}`)}
            >
              {allFormData.map((info, idx) => (
                <option value={info?._id} key={idx}>
                  {info?.name}
                </option>
              ))}
            </CFormSelect>
          </div>
          <CButton
            className="text-white px-3"
            onClick={handleDownload}
            style={{ pointerEvents: 'auto', fontSize: '18px', background: '#20211c' }}
          >
            <img src={DownloadIcon} alt="DownloadIcon" style={{ height: '15px' }} /> Download
          </CButton>
        </div>
      </div>
      <CCard
        style={{
          overflowX: 'auto',
          overflowY: 'hidden',
          width: '100%',
        }}
        className=" custom-scrollbar-horizontal position-relative "
      >
        {!isEmpty(previewInfo) && (
          <FormPreview
            onClose={() => setPreviewInfo([])}
            cardImage={getThumbnail(
              userSessionObj.session_data.cf_domain_name,
              formData?.thumbnail?.s3_key,
            )}
            headline="Form Response Preview"
            subHeadline={`Detailed information of Response`}
            basicInfo={previewInfo}
            disableDataHeight={true}
          />
        )}

        <div
          className="bg-black"
          style={{
            width: `max(${formData?.fields?.data.length * 15.3125 + 21.927083333}vw, 100%)`,
            whiteSpace: 'nowrap',
            fontWeight: '550',
            fontSize: '12px',
          }}
        >
          <div
            style={{ display: 'inline-block', width: '5.78125vw' }}
            className="text-center text-white "
          >
            # Sl No.
          </div>
          {!isEmpty(formData) &&
            [...formData?.fields?.data, { name: 'Created on' }].map((info, idx) => (
              <div
                key={idx}
                style={{ display: 'inline-block', width: '15.3125vw' }}
                className="text-white "
              >
                {info.name}
              </div>
            ))}
        </div>

        <InfiniteScroll
          dataLength={responseData.length} //This is important field to render the next data
          next={handleNextPage}
          hasMore={
            formResponseData?.data?.responses &&
            formResponseData?.data?.responses?.total > page * 20
          }
          style={{
            width: `max(${formData?.fields?.data.length * 15.419270833 + 21.200520833}vw,100%)`,
          }}
          loader={<p>Loading...</p>}
          className="custom-scrollbar-vertical"
          height={`65vh`}
          scrollableTarget="scrollableDiv"
        >
          <div
            className="d-flex flex-wrap"
            style={{
              gap: '1.2vw 0',
              padding: '15px 8px 20px 8px',
              width: '100%',
            }}
          >
            {!isEmpty(responseData)
              ? responseData.map((ele, index) => {
                  let info = ele.form_data.fields
                  let textData = info.map((data, i) => ({
                    name: data?.value,
                    styles: { width: '15.419270833vw' },
                  }))
                  return (
                    <FormAnalyticsCard
                      textData={[
                        {
                          name: `${index + 1}.`,
                          styles: { width: '5.364583333vw', textAlign: 'center' },
                        },
                        ...textData,
                        {
                          name: moment(ele?.created_date).format('DD MMM YYYY'),
                          styles: { width: '15.419270833vw' },
                        },
                      ]}
                      key={index}
                      onClick={() =>
                        handlePreview(info, moment(ele?.created_date).format('DD MMM YYYY'))
                      }
                    />
                  )
                })
              : null}
          </div>
        </InfiniteScroll>
      </CCard>
    </>
  )
}

export default FormAnalyticsDetails
